<template>
    <el-card class="operation-container noBorder">
        <Transition name="fade">
            <el-form
                v-if="formVisible"
                :inline="true"
                class="search-form"
                :model="search_data"
                style="padding: 0"
                label-position="top"
            >
                <el-form-item label="字典名称">
                    <el-select
                        v-if="getDictDataListsOptions.length > 0"
                        v-model="search_data.dict_id"
                        clearable
                        placeholder="字典名称"
                    >
                        <el-option
                            v-for="item in getDictDataListsOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="search_data.status" clearable placeholder="请选择">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-left: auto; padding-top: 10px">
                    <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
        </Transition>
        <div style="display: flex; margin-bottom: 10px">
            <el-button type="primary" :icon="Plus" @click="onAddClick()">添加</el-button>
            <el-button :icon="Download" @click="importsVisible = true">导入</el-button>
            <el-button @click="handleExport" :icon="Upload">导出</el-button>

            <el-button :icon="DCaret" @click="handleSort">一键排序</el-button>
            <el-button :icon="Close" @click="handleClose">关闭</el-button>

            <div class="card-header" style="margin-left: auto">
                <div class="circle-btn">
                    <el-tooltip class="box-item" effect="dark" :content="formVisible ? '隐藏搜索' : '显示搜索'" placement="top">
                        <el-button plain circle @click="formVisible = !formVisible" :icon="Search" size="small"></el-button>
                    </el-tooltip>
                    <el-tooltip class="box-item" effect="dark" content="刷新" placement="top">
                        <el-button plain circle @click="getTableData" :icon="Refresh" size="small"></el-button>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <el-table :data="table_data" v-loading="tableLoading" border style="width: 100%">
            <el-table-column label="序号" width="60" type="index"></el-table-column>
            <el-table-column prop="label" label="字典标签">
                <template #default="{ row }">
                    <span v-if="row.list_class === 'default' || !row.list_class">{{ row.label }}</span>
                    <el-tag v-else :type="row.list_class">{{ row.label }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="value" label="字典键值"></el-table-column>
            <el-table-column prop="list_order" label="字典排序" width="130">
                <template #default="scope">
                    <el-input-number
                        style="width: 100px"
                        type="number"
                        v-model="scope.row.list_order"
                        :min="0"
                        :max="999999"
                        controls-position="right"
                        size="small"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="default" label="默认" width="80">
                <template #default="{ row }">
                    <el-popover placement="right" trigger="hover" popper-class="hover-class">
                        <span class="selectTag" @click="onDefaultClick(row, $index)">
                            {{ row.default ? `移除` : '设置为' }}默认
                        </span>
                        <template #reference>
                            <el-tag v-if="!row.default" type="primary" class="defalut">否</el-tag>
                            <el-tag v-else type="success" class="defalut">是</el-tag>
                        </template>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80">
                <template #default="{ row }">
                    <el-tag v-if="row.status == 1">正常</el-tag>
                    <el-tag v-else type="danger">停用</el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" sortable width="200"></el-table-column>
            <el-table-column label="操作" width="200">
                <template #default="{ row, $index }">
                    <el-button type="primary" link :icon="Edit" circle @click="onEditClick(row)">修改</el-button>
                    <el-button v-if="!row.preset" type="primary" link :icon="Delete" circle @click="onRemoveClick(row, $index)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="search_data.page"
            :page-sizes="[10, 20, 50]"
            :page-size="search_data.page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
        <forms-dialog
            v-model="formDialogVisible"
            :isForm="isForm"
            :roleId="selectId"
            :dictDataCode="dictDataCode"
            @updateForm="getTableData"
        ></forms-dialog>
        <imports-form v-model="importsVisible" @updateForm="getTableData"></imports-form>
    </el-card>
</template>

<script setup>
import { onActivated, ref, watch } from 'vue'
import { batchSort, defaultDelDictData, defaultDictData, delDictData, getDictDatatList } from '@/api/dictdata.js'
import { getDictOptionLists } from '@/api/dict.js'
import FormsDialog from './components/dialog.vue'
import ImportsForm from './components/ImportsForm.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Close, DCaret, Delete, Download, Edit, Plus, Refresh, Search, Upload } from '@element-plus/icons'
import { useRoute, useRouter } from 'vue-router'

const tableLoading = ref(true)
const table_data = ref([])
const dictDataCode = ref('')
const route = useRoute()
const router = useRouter()
const getDictDataListsOptions = ref([])
const search_data = ref({
    dict_id: route.params.id,
    status: null,
    page: 1,
    page_size: 10
})
// 获取字典管理列表
const getTableData = async () => {
    tableLoading.value = true
    const dictOptionLists = await getDictOptionLists()
    getDictDataListsOptions.value = dictOptionLists.map((v) => ({
        label: v.name,
        value: v.id,
        code: v.code
    }))
    dictDataCode.value = dictOptionLists.filter((v) => v.id === search_data.value.dict_id)[0]?.code ?? ''
    const result = await getDictDatatList({ ...search_data.value, dict_code: dictDataCode.value })
    tableLoading.value = false
    table_data.value = result.lists
    total.value = result.total
}
// 获取字典选项列表
const getDictDataList = async () => {
    const result = await getDictOptionLists()
    getDictDataListsOptions.value = result.map((v) => ({
        label: v.name,
        value: v.id,
        code: v.code
    }))
}
getDictDataList()
getTableData()
// 数据源

const total = ref(0)
const statusOptions = [
    { label: '正常', value: 1 },
    { label: '停用', value: 0 }
]

// 重置
const resetQueryForm = () => {
    Object.keys(search_data.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size' && key !== 'dict_id') search_data.value[key] = ''
    })
    getTableData()
}
const formVisible = ref(true)

getTableData()

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectId = ref('') // 点中的运营单位id
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) {
        selectId.value = ''
    }
})
const importsVisible = ref(false)

// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    search_data.value.page_size = currentSize
    getTableData()
}
// 页码改变触发
const handleCurrentChange = (currentPage) => {
    search_data.value.page = currentPage
    getTableData()
}
// 关闭按钮回到上一页
const handleClose = () => {
    router.go(-1)
}

// 编辑
const onEditClick = (row) => {
    selectId.value = row.id
    isForm.value = true
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    selectId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}
// 删除

const onRemoveClick = (row, index) => {
    ElMessageBox.confirm('确定要删除字典编码为' + (index + 1) + '的数据项吗？', {
        type: 'warning'
    })
        .then(async () => {
            await delDictData(row.id)
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getTableData()
        })
        .catch(() => {})
}
// 是否移除默认
const onDefaultClick = (row, index) => {
    ElMessageBox.confirm(`是否${row.default ? '移除' : '设置为'}默认?`, {
        type: 'warning'
    })

        .then(async () => {
            row.default ? await defaultDelDictData(row.id) : await defaultDictData(row.id)
            ElMessage.success('设置成功')
            // 重新渲染数据
            getTableData()
        })
        .catch(() => {})
}
// const importsVisible = ref(false)

const handleExport = () => {
    ElMessageBox.confirm('是否确认导出字典数据', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const data = await getDictDatatList({ ...search_data.value, dict_code: dictDataCode.value, export: 1 })
            window.open(data.data)
            ElMessage({
                type: 'success',
                message: '导出成功'
            })
        })
        .catch(() => {})
}
const handleSort = async () => {
    const soreObj = {}
    if (table_data.value.length === 0) return
    table_data.value.forEach((ele) => {
        soreObj[ele.id] = ele.list_order
    })
    await batchSort(soreObj)
    ElMessage.success('操作成功')
    getTableData()
}

// 被 keep-alive 缓存的组件激活时调用
onActivated(() => {
    search_data.value.status = null
    search_data.value.dict_id = route.params.id
    getTableData()
})
</script>

<style lang="scss" scoped>
.header {
    margin-bottom: 20px;
}

.demo-date-picker {
    display: flex;
    width: 100%;
    padding: 0;
    flex-wrap: wrap;
}

.demo-date-picker .block {
    text-align: center;
    border-right: solid 1px var(--el-border-color);
    flex: 1;
}

.demo-date-picker .block:last-child {
    border-right: none;
}
.hover-class {
    display: flex;
    justify-content: center;
    color: var(--theme-color) !important;
    cursor: pointer;
}
.defalut {
    cursor: pointer;
}
.selectTag {
    cursor: pointer;
}
.pagination {
    float: right;
}
</style>
